import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output } from '@angular/core';
import { Clipboard } from '@angular/cdk/clipboard';
import { animate, state, style, transition, trigger } from '@angular/animations';

import { DialogService } from 'primeng/dynamicdialog';
import { find } from 'lodash';

import { CalculationService, DataService, DateService, HelperService, HTTPService } from 'app/services';
import { config, messages, mileageUnits, motorLinkedOptions, vehicleTransmissions } from 'app/constants';
import { datetimeFormat } from 'app/constants/date-time-format';

import { DuplicateVehicleDialogComponent } from '../duplicate-vehicle-dialog/duplicate-vehicle-dialog.component';
import { CarfaxVehicleHistoryComponent } from '../carfax-vehicle-history/carfax-vehicle-history.component';
import { UnsyncVehicleDialogComponent } from '../unsync-vehicle-dialog/unsync-vehicle-dialog.component';
import { AddVehicleHistoryComponent } from '../add-vehicle-history/add-vehicle-history.component';
import { MergeVehicleDialogComponent } from 'app/modules/app-components/merge-vehicle-dialog/merge-vehicle-dialog.component';

import { debounce } from 'lodash';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { TransferVehicleDialogComponent } from '../transfer-vehicle-dialog/transfer-vehicle-dialog.component';
import { ConfirmDismissDialogComponent } from 'app/modules/shared/components';
import { CreateMyFleetCustomerDialogComponent } from '../create-myfleet-customer-dialog/create-myfleet-customer-dialog.component';
import { customerSchema } from 'app/constants/schema';
import { ICustomer } from 'app/services/order';

@Component({
  selector: 'app-vechicle-item',
  templateUrl: './vechicle-item.component.html',
  styleUrls: ['./vechicle-item.component.scss'],
  providers: [DialogService],
  animations: [
    trigger('toggleBox', [
      state(
        'open',
        style({
          height: '100px',
        }),
      ),
      state(
        'closed',
        style({
          height: '0px',
        }),
      ),
      transition('open => closed', [animate('.3s')]),
      transition('closed => open', [animate('0.3s')]),
    ]),
  ],
})
export class VechicleItemComponent implements OnInit, OnChanges, OnDestroy {
  @Input() index: number;
  @Input() vehicle: any = {};
  @Input() apiConfig: any = {};
  @Input() driveTypes: any[] = [];
  @Input() vehicleTags: any[] = [];
  @Input() vehicleOdmHistory: any[] = [];
  @Input() customerId: string = '';
  @Input() customer: ICustomer = customerSchema;
  @Input() isFleetCustomer: string = '';
  @Input() vehicleColors: any[] = [];
  @Input() isCarfaxEnabled: boolean = false;
  @Input() isMotorLookupEnabled: boolean = false;
  @Input() isTireStorageEnabled: boolean = false;
  @Input() openConnectMotor: boolean = false;
  @Input() highLightedVIN: boolean = false;
  @Input() highLightedMiles: boolean = false;
  @Input() highLightedVehicleId: string = '';
  @Input() vehicleSearchPlaceholder: string = '';
  @Input() defaultMileageUnit: string = '';
  @Input() defaultRegState: string = '';
  @Input() defaultRegStateCode: string = '';
  @Input() vehicles: any[] = [];
  @Input() vehicleList: any;
  @Input() isMyFleetCenterEnabled: boolean = false;

  @Output() updateTags = new EventEmitter();
  @Output() vehicleUpdate = new EventEmitter();
  @Output() updateTagList = new EventEmitter();
  @Output() updateVehicleConnectedStatus = new EventEmitter();
  @Output() addTireStorageModal = new EventEmitter();

  private _drivers: any[] = [];

  @Input()
  set drivers(value: any[]) {
    this._drivers = [{ fullName: 'No driver', employeeNumber: null }, ...value];
    this.getSelectedDriver();
  }

  get drivers(): any[] {
    return this._drivers;
  }

  source:string
  isOpen: boolean;
  isDataChange: boolean = false;
  transmissions: any[] = vehicleTransmissions;
  mileageUnits: any[] = mileageUnits;
  driverTypeSuggestions: any[] = this.driveTypes;
  vehicleColorsSuggestions: any[] = this.vehicleColors;
  errors: any = {};
  query: any = {};
  isSearchFieldVisible: boolean = false;
  vehicleSuggestions: any[] = [];
  stateResults: any[] = [];
  vehicleQuery: string = '';
  isSearchingVehicle: boolean = false;
  isStateSearching: boolean = false;
  apiResponse: any = null;
  motorLinkedOptions: any[] = motorLinkedOptions;
  tooltip: string = '';
  searchType: string = '';
  focus: any = {};
  disabled: any = {};
  isCarfaxConnecting: boolean = false;
  isVinFocused: boolean = false;
  isVehicleNameUnique: boolean = false;
  isSavingVehicle: boolean = false;
  isFocused: boolean = false;
  vinInputVisible: boolean = false;
  licenseInputVisible: boolean = false;
  vinExsistErrMsg = '';
  lincencePlateErrMsg = '';
  vehicleAlreadyAdded = false;
  customerList: any = [];
  isDuplicateVehicle: boolean = false;
  selectedVehicle: any = [];
  type: any;
  defaultVehicles: any[] = [];
  // vehicleList: any[] = [];
  isVehiclesLoading: boolean = false;
  OdmHistory: any = [];
  private unsubscribe: Subject<boolean> = new Subject<boolean>();
  isTransferVehicleEnabled: boolean = false;
  isTransferringVehicle: boolean = false;
  currentCustomer: any = {};
  openAccordion = -1;
  isClearIconVisible = false;
  closeAfterAction: boolean;
  contact: any = {};
  isProcessing: boolean = false;
  isRegStateMandatory: boolean = false;
  isLicensePlateMandatory: boolean = false;
  isCompatibilityBannerVisible: boolean = false;
  fieldPlaceholder = {
    licensePlate: 'License Plate',
    regState: 'Registration State',
  };

  constructor(
    private httpService: HTTPService,
    private helperService: HelperService,
    private dateService: DateService,
    private dataService: DataService,
    private calculationService: CalculationService,
    private dialogService: DialogService,
    private cdr: ChangeDetectorRef,
    private clipboard: Clipboard,
  ) {}

  ngOnInit() {
    this.driverTypeSuggestions = this.helperService.deepCopy(this.driveTypes);
    this.vehicleColorsSuggestions = this.helperService.deepCopy(this.vehicleColors);
    this.apiResponse = this.vehicle.apiResponse;
    this.setMotorLinkTooltip();
    this.disabled = this.helperService.setVehicleDisabledFields(this.vehicle.isMotorConnected, this.vehicle.isCarfaxConnected, this.vehicle.connectedVia);
    this.isFocused = this.highLightedVehicleId === this.vehicle._id;
    this.isTransferVehicleEnabled = this.dataService.isTransferVehicleEnabled;
    this.isMyFleetCenterEnabled = this.dataService.isMyFleetCenterEnabled && this.dataService.isMyFleetCenterConnected;

    this.setDataListener();

    if (this.vehicle && this.vehicle.vin && this.vehicle.vin.length < 11) {
      this.errors.vin = 'Incomplete VIN';
    }
    if (this.highLightedVehicleId === this.vehicle._id && this.openConnectMotor) {
      if (this.vehicle.isMotorAndCarfaxSynced) {
        this.showVehicleSearchField();
      } else {
        this.openChooseVehicleDialog();
      }
    }
    if (this.highLightedVehicleId === this.vehicle._id && this.highLightedVIN) {
      this.focus.vin = this.highLightedVehicleId === this.vehicle._id;
    }
    if (this.highLightedVehicleId === this.vehicle._id && this.highLightedMiles) {
      this.focus.miles = this.highLightedVehicleId === this.vehicle._id;
    }
    if (this.vehicle.transferDetails && this.vehicle.transferDetails.vehicleTransferDate) {
      this.vehicle.transferDetails.vehicleTransferDate = this.dateService.formatDate(this.vehicle.transferDetails.vehicleTransferDate, datetimeFormat.mmmdyyyy);
    }

    this.getSelectedDriver();
    this.validate();
  }

  ngOnChanges(change) {
    const { driveTypes, vehicleColors } = change;
    if (driveTypes) {
      if (driveTypes.previousValue && driveTypes.currentValue && driveTypes.previousValue !== driveTypes.currentValue) {
        const changes = {};
        driveTypes.currentValue.forEach(({ _id, name }) => {
          changes[_id] = name;
        });
        this.driverTypeSuggestions.forEach((data, index) => {
          if (changes[data._id]) {
            this.driverTypeSuggestions[index].name = changes[data._id];
          }
        });
      }
    }

    if (vehicleColors) {
      if (vehicleColors.previousValue && vehicleColors.currentValue && vehicleColors.previousValue !== vehicleColors.currentValue) {
        const changes = {};
        vehicleColors.currentValue.forEach(({ _id, name }) => {
          changes[_id] = name;
        });
        this.vehicleColorsSuggestions.forEach((data, index) => {
          if (changes[data._id]) {
            this.vehicleColorsSuggestions[index].name = changes[data._id];
          }
        });
      }
    }
  }

  ngOnDestroy() {
    this.unsubscribe.next(true);
    this.unsubscribe.unsubscribe();
  }

  setDataListener() {
    this.setFeatureFlags();
    this.dataService
      .getData()
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(({ data }) => {
        if (!data) return;
        const { _id, fullName, key, tab, type } = data;

        if (type === 'update') {
          if (this.customerId) {
            this.getAllVehicles(this.customerId);
          }
        }

        if (key === 'sidebar-driver-update') {
          // Clear the vehicle driver if it's the updated driver and is inactive
          if (this.vehicle?.driver?._id === data?.data?._id) {
            this.vehicle.driver = data?.data;
            if (!data?.data?.isActive) {
              this.vehicle.driver = {};
            }
          }
        }

        if (key === 'company-appdata-updated') {
          this.setFeatureFlags();
        }
      });
  }

  setFeatureFlags() {
    if (this.dataService.isCustomerVehicleMandatoryFieldsEnabled) {
      this.isRegStateMandatory = this.dataService.isRegStateMandatory;
      this.isLicensePlateMandatory = this.dataService.isLicensePlateMandatory;
    }

    this.fieldPlaceholder.licensePlate = `License Plate${this.isLicensePlateMandatory ? '*' : ''}`;
    this.fieldPlaceholder.regState = `Registration State${this.isRegStateMandatory ? '*' : ''}`;
  }

  /** Getting customer vehicles */
  getAllVehicles(customerId: string, fetchTags: boolean = false) {
    this.isVehiclesLoading = true;
    this.httpService.getVehiclesByCustomer(customerId, fetchTags).then(
      (data: any) => {
        this.isVehiclesLoading = false;

        if (!data) {
          return;
        }

        const { vehicles } = data;

        this.vehicleList = this.formatVehicles(vehicles);
        this.defaultVehicles = this.helperService.deepCopy(this.vehicleList);
        this.dataService.sendData(this.dataService.typePassData('customer-vehicle-list', { vehicles: this.vehicleList }));
      },
      (err) => {
        this.isVehiclesLoading = false;
        this.helperService.showToaster('error', err);
      },
    );
  }

  formatVehicles(vehicles: any[]) {
    return vehicles.map((vehicle) => {
      const { ODM, VIN, year, vehicleName, transmission, connectedVia, isCarfaxConnected, name } = vehicle;

      vehicle.isCarfaxConnected = isCarfaxConnected;
      vehicle.connectedVia = connectedVia;
      vehicle.vin = VIN || '';
      if (VIN) {
        vehicle.defaultVin = this.helperService.deepCopy(VIN);
      }
      vehicle.year = `${year || ''}`;
      vehicle.vehicleName = '';
      vehicle.vehicleName = vehicleName || name || '';
      vehicle.odmHistory = [];

      if (vehicle.licensePlateNo && !vehicle.registrationStateCode) {
        vehicle.registrationState = this.defaultRegState;
        vehicle.registrationStateCode = this.defaultRegStateCode;
        vehicle.state = vehicle.registrationState;
      }

      vehicle.transmission = find(vehicleTransmissions, { value: transmission }) || {};

      if (ODM && ODM.length) {
        this.OdmHistory[vehicle._id] = ODM.map((odm: any) => ({
          ...odm,
          readingDate: this.dateService.getCurrentDateTimeTz(new Date(odm.readingDate).getTime()),
        }));

        let { reading, mileageMeasuringUnit } = ODM[ODM.length - 1];

        vehicle.mileage = `${reading || ''}`;

        if (reading) {
          if (!mileageMeasuringUnit) {
            mileageMeasuringUnit = this.defaultMileageUnit;
          }

          vehicle.mileageMeasuringUnit = find(mileageUnits, {
            value: mileageMeasuringUnit,
          });
        }
      }

      return vehicle;
    });
  }

  handleChange(name: string, value: any) {
    this.vehicle[name] = value;

    if (name === 'vehicleName') {
      this.checkVehicleNameUniqueness();
    }
  }

  handleOpenStateDropdown(close: any) {
    if (close) {
      close(false);
    }

    this.focus.state = true;
    this.onStateSearch(this.vehicle.state);
  }

  onMileageUnitSelect(value: any) {
    if (this.vehicle.mileageMeasuringUnit && this.vehicle.mileageMeasuringUnit.value === value.value) {
      return;
    }
    this.vehicle.mileage = this.calculationService.convertMileageIntoUnit(this.vehicle.mileage, value.value);
    this.vehicle.mileageMeasuringUnit = value;
  }

  onVehicleDriverSelect(value: any) {
    this.isClearIconVisible = true;
    this.vehicle.driver = value;
  }

  handleFocus(name: string) {
    // this.errors[name] = '';
  }

  handleBlur(name: string) {
    // this.errors[name] = false;
    this.focus[name] = false;

    if (name === 'vin' && this.vehicle.vin && this.vehicle.vin.length < 11) {
      this.errors.vin = 'Incomplete VIN';
    }

    if (name === 'vehicleName') {
      this.checkVehicleNameUniqueness();
    }
    this.vinInputVisible = false;
  }

  onFocusTitle() {
    this.vinInputVisible = true;
    this.cdr.detectChanges();
  }

  handleMotorOptionSelect({ value }) {
    if (value === 'disconnect') {
      this.onVehicleSelect(null);
    } else {
      // this.highLightedVehicleId = this.vehicle._id;
      this.showVehicleSearchField();
    }
  }

  setMotorLinkTooltip() {
    if (this.apiResponse && this.apiResponse.BaseVehicleID) {
      this.tooltip = 'Connected to Motor \n ';

      if (this.vehicle.vin) {
        this.tooltip += `VIN: ${this.vehicle.vin}`;
      } else {
        const { Year, MakeName, ModelName, SubModelName } = this.apiResponse;
        this.tooltip += `YMM: ${Year} ${MakeName} ${ModelName} ${SubModelName}`;
      }
    }
  }

  toggle() {
    this.isOpen = !this.isOpen;
  }

  /** Clear search suggestion */
  onSuggestionsClear(type: string) {
    this.query[type] = '';
    if (type === 'color') {
      this.vehicleColorsSuggestions = this.helperService.deepCopy(this.vehicleColorsSuggestions);
    } else {
      this.driveTypes = this.helperService.deepCopy(this.driverTypeSuggestions);
    }
  }

  onStateSelect({ state, stateCode }) {
    this.vehicle.registrationState = state;
    this.vehicle.registrationStateCode = stateCode;
    this.vehicle.state = state;

    if (this.isSearchFieldVisible) {
      this.focus.search = true;
      this.onSearchVehicle(this.vehicleQuery);
    }
  }

  onClear() {
    this.vehicle.registrationState = '';
    this.vehicle.registrationStateCode = '';
    this.stateResults = [];
  }

  onClearVIN() {
    this.errors.vin = '';
    this.errors.licensePlateNo = '';
  }

  onStateSearch(search: string = '') {
    this.isStateSearching = true;
    this.httpService.stateSearch({ search }).then(
      (res) => {
        if (res.states) {
          this.stateResults = res.states;
        }
        this.isStateSearching = false;
      },
      (err) => {
        this.isStateSearching = false;
      },
    );
  }

  openDuplicateVehicleModal() {
    const ref = this.dialogService.open(DuplicateVehicleDialogComponent, {
      width: '500px',
      styleClass: 'add-dialog',
      showHeader: false,
      data: {
        customerList: this.customerList,
        customerId: this.customerId,
        vehicleName: this.vehicle.vehicleName,
        isShow: true,
      },
    });

    const onClose = ref.onClose.subscribe((data) => {
      if (data.type === 'close' || data.type === 'showOnly') {
        this.isDuplicateVehicle = true;
        this.errors.vin = '';
        this.errors.licensePlateNo = '';
        this.onSubmit();
        onClose.unsubscribe();
      }
    });
  }

  validate() {
    let isValid = true;
    this.isCompatibilityBannerVisible = false;
    this.errors = {
      ...this.errors,
      licensePlateNo: '',
      registrationState: '',
    };

    if (this.isRegStateMandatory && !this.vehicle.registrationState) {
      this.isCompatibilityBannerVisible = true;
      this.errors.registrationState = 'Registration state required';
      isValid = false;
    }

    if (this.isLicensePlateMandatory && !this.vehicle.licensePlateNo) {
      this.isCompatibilityBannerVisible = true;
      this.errors.licensePlateNo = 'License plate required';
      isValid = false;
    }

    return isValid;
  }

  onSubmit(isTransferringVehicle = false) {
    if (this.errors.vehicleName || !this.validate()) return;

    const { vin, year, make, model, color, mileage, driveType, transmission, registrationState, mileageMeasuringUnit, registrationStateCode, tags } = this.vehicle;
    let odm: any = {};

    if (mileage) {
      odm = {
        reading: mileage,
        readingDate: this.dateService.currentDate(),
      };
      if (mileageMeasuringUnit && mileageMeasuringUnit.value) {
        odm.mileageMeasuringUnit = mileageMeasuringUnit.value;
      }
    }

    const vehicle = {
      ...this.helperService.deepCopy(this.vehicle),
      year,
      make,
      model,
      VIN: vin,
      ODM: [odm],
      tags,
      color: color && color.name,
      registrationState: registrationState,
      driveType: driveType && driveType.name,
      registrationStateCode: registrationStateCode,
      transmission: transmission && transmission.value,
      defaultVin: this.vehicle.defaultVin,
    };
    vehicle.name = `${year || ''} ${make || ''} ${model || ''}`;
    vehicle.customerId = this.customerId;

    delete vehicle.connectedVia;
    if (isTransferringVehicle) {
      this.isTransferringVehicle = true;
    } else {
      this.isSavingVehicle = true;
    }

    //isTransferVehicleEnabled feature flag, and updating the vehicle
    if (this.isTransferVehicleEnabled) {
      if (vehicle.VIN) {
        if (this.isTransferringVehicle) {
          vehicle.isVehicleTransfer = true;
        } else if (this.isSavingVehicle && this.vehicle.isTransferActive) {
          vehicle.isVehicleTransfer = true;
        } else if (vehicle.VIN !== vehicle.defaultVin) {
          vehicle.isVehicleTransfer = true;
        } else {
          vehicle.isVehicleTransfer = false;
        }
      } else {
        vehicle.isVehicleTransfer = false;
      }
    } else {
      if (!this.isDuplicateVehicle) {
        vehicle.vehicleCheck = true;
      } else {
        vehicle.vehicleCheck = false;
      }
    }

    if (this.vehicle?.driver) {
      vehicle.driver = {
        driverId: this.vehicle?.driver?._id,
        name: this.vehicle?.driver?.fullName,
        ...this.vehicle.driver,
      };
    } else if (this.vehicle?.driver?.fullName === 'No driver') {
      vehicle.driver = null;
    }

    this.httpService
      .updateVehicle(vehicle)
      .then(
        ({ isTagUpdated, followUps }) => {
          this.vehicleUpdate.emit(this.vehicle);
          this.helperService.showToaster('success', messages.vehicleInfoUpdate);

          this.dataService.sendData(this.dataService.typePassData('vehicle', { _id: this.customerId, vehicle, from: '' }));

          if (isTagUpdated && followUps.length) {
            this.dataService.sendData(
              this.dataService.typeFollowUp('RO', {
                vehicle,
                event: 'vehicle_created',
                followUps: vehicle.followUps,
                customerId: vehicle.customerId,
              }),
            );
          }

          if (this.highLightedVehicleId) {
            this.dataService.sendData(
              this.dataService.typeSidebar('close', null, null, {
                isSuccess: true,
                vehicle: {
                  ...vehicle,
                  isMotorConnected: !!this.apiResponse,
                },
                type: 'ro-vehicle',
              }),
            );
          }
        },
        (err) => {
          if (err.data.vinMatch > 0) {
            this.vinInputVisible = true;
            this.errors.vin = 'This VIN already exists,';
          }
          if (err.data.licenseMatch > 0) {
            this.licenseInputVisible = true;
            this.errors.licensePlateNo = 'This vehicle already exists,';
          }

          this.vinExsistErrMsg = err.data.vinMatch + (err.data.vinMatch === 1 ? ' vehicle match found' : ' vehicle matches found');
          this.lincencePlateErrMsg = err.data.licenseMatch + (err.data.licenseMatch === 1 ? ' vehicle match found' : ' vehicle matches found');
          this.vehicleAlreadyAdded = true;
          this.customerList = [];
          this.currentCustomer = err.data.currentCustomer;

          if (err.data.customers) {
            err.data.customers.forEach((c) => {
              if (c.vehicles) {
                c.vehicles.map((v) => {
                  return (v.isChecked = false);
                });
              }
              this.customerList.push(c);
            });

            if (this.isTransferVehicleEnabled) {
              this.errors.transferVehicleError = 'Vehicle also exists under customer';
              this.vehicle.isTransferButtonEnabled = true;

              if ((this.isTransferVehicleEnabled && this.vehicle.isTransferActive) || (err.data.differentUser && this.isTransferringVehicle)) {
                this.handleOpenTransferVehicleDialog();
              } else {
                if (this.customerList[this.customerList.length - 1].customerId === err.data.currentCustomer._id) {
                  this.vehicle.isTransferButtonEnabled = false;
                  this.handleVehicleDuplication(err.data.customers[err.data.customers.length - 1].vehicles);
                }
              }
            } else {
              if (!this.isTransferVehicleEnabled) {
                this.openDuplicateVehicleModal();
              }
            }
          }
          if (typeof err === 'string') {
            this.helperService.showToaster('error', err);
          }
        },
      )
      .finally(() => {
        if (isTransferringVehicle) {
          this.isTransferringVehicle = false;
        } else {
          this.isSavingVehicle = false;
        }
      });
  }

  onTransmissionSelect(value: any) {
    this.vehicle.transmission = value;
  }

  onDriverTypeSelect(driverType: any) {
    this.vehicle.driveType = { name: driverType.name };
  }

  onVehicleColorSelect(color: any) {
    this.vehicle.color = { name: color.name };
  }

  onSearchDriverType(value: string) {
    const query = value.toLowerCase();
    this.driverTypeSuggestions = this.driveTypes.filter(({ name }) => name && name.toLowerCase().includes(query));
  }

  onSearchVehicleColor(value: string) {
    const query = value.toLowerCase();
    this.vehicleColorsSuggestions = this.vehicleColors.filter(({ name }) => name && name.toLowerCase().includes(query));
  }

  openVehicleInSidepanel(value: any, h: any) {}

  onChangeFleetConnection(type?) {
    this.closeAfterAction = !this.closeAfterAction;
    if (type === 'disconnect') {
      this.vehicle.isMFConnected = false;
      this.onSubmit();
    } else {
      this.handleOpenFleetCustomer();
    }
  }

  handleOpenFleetCustomer() {
    const ref = this.dialogService.open(CreateMyFleetCustomerDialogComponent, {
      styleClass: 'add-dialog item-dialog new-part',
      showHeader: false,
      data: {
        fleetName: this.customer.firstName,
        fleetNumber: this.customer.fleetNumber,
        customer: this.customer,
        vehicle: this.vehicle,
        openFrom: 'vehicle',
      },
    });
    const onClose = ref.onClose.subscribe((response: any) => {
      if (response.isVehicleUpdated) {
        this.vehicle = {
          ...response?.vehicle,
          vin: response?.vehicle?.VIN,
          vehicleCheck: false,
        };
      }
      onClose.unsubscribe();
    });
  }

  onTagSelect(tag: any) {
    this.vehicle.tags.push({
      categoryId: tag._id,
      name: tag.name,
      color: tag.color,
    });
  }

  onTagDelete(tags: any[]) {
    this.vehicle.tags = tags;
  }

  onTagCreate(tag: any) {
    this.vehicleTags = [...this.vehicleTags, tag];
  }

  updateVehicleTags(tag: any) {
    this.updateTags.emit(tag.current);
  }

  deleteVehicleTags(tags: any[]) {
    this.updateTagList.emit(tags);
  }

  getDriverTypes() {
    this.httpService.getTags(config.category.driveType).then(
      (driveTypes: any[]) => {
        if (driveTypes && driveTypes.length) {
          this.driveTypes = driveTypes;
          this.driverTypeSuggestions = driveTypes;
        }
      },
      (error) => {
        this.helperService.showToaster('error', error);
      },
    );
  }

  /** Fetch all vehicle color tags */
  getVehicleColors() {
    this.httpService.getTags(config.category.vehicleColor).then(
      (colors: any[]) => {
        if (colors && colors.length) {
          this.vehicleColors = colors;
          this.vehicleColorsSuggestions = colors;
        }
      },
      (err) => {
        this.helperService.showToaster('error', err);
      },
    );
  }

  handleTagDelete(deletedTag: any) {
    if (this.vehicleTags && this.vehicleTags.length) {
      this.vehicleTags = this.vehicleTags.filter(tag => {
        if (deletedTag._id) {
          return tag._id !== deletedTag._id;
        } else {
          return !(tag.name === deletedTag.name && tag.color === deletedTag.color);
        }
      });
    }
  }

  onCreateDriverType({ name, isForFurtureUse }) {
    if (name) {
      const trimmedName = name.trim();
      const duplicate = this.driverTypeSuggestions.some(
        (type) => type.name.toLowerCase() === trimmedName.toLowerCase()
      );

      if (duplicate) {
        this.helperService.showToaster('error', 'Drive type already exists.');
        return;
      }

      this.httpService
        .createTag({
          name: trimmedName,
          type: config.category.driveType,
          isForFurtureUse,
        })
        .then(
          (driverType) => {
            this.driveTypes.push(driverType);
            this.driverTypeSuggestions.push(driverType);
            this.onDriverTypeSelect(driverType);
          },
          (err) => {
            this.helperService.showToaster('error', err);
          },
        );
    }
  }

  onVehicleColorCreate({ name, isForFurtureUse }) {
    if (name) {
      this.httpService
        .createTag({
          name: name.trim(),
          isForFurtureUse,
          type: config.category.vehicleColor,
        })
        .then(
          (vehicleColor) => {
            this.vehicleColors.push(vehicleColor);
            this.vehicleColorsSuggestions.push(vehicleColor);
            this.onVehicleColorSelect(vehicleColor);
          },
          (error) => {
            this.helperService.showToaster('error', error);
          },
        );
    }
  }

  showVehicleSearchField() {
    this.isSearchFieldVisible = true;
    const { vin = '', year = '', make = '', model = '' } = this.vehicle;
    let searchBy = '';
    this.highLightedVehicleId = this.vehicle._id;
    if (this.apiResponse && this.apiResponse.BaseVehicleID) {
      const { Year = '', MakeName = '', ModelName = '', SubModelName = '' } = this.apiResponse;
      this.vehicleQuery = `${Year} ${MakeName} ${ModelName} ${SubModelName}`;
    } else {
      if (this.isCarfaxEnabled && this.vehicle.licensePlateNo) {
        this.vehicleQuery = this.vehicle.licensePlateNo;
        searchBy = 'license';
      } else if (vin) {
        this.vehicleQuery = vin;
        searchBy = 'VIN';
      } else {
        this.vehicleQuery = `${year} ${make} ${model}`;
        searchBy = 'ymm';
      }
    }
    this.focus.search = true;
    this.onSearchVehicle(this.vehicleQuery, searchBy);
  }

  onSearchVehicle(query: string, searchBy: string = '') {
    const company = this.helperService.getCompany();
    this.vehicleQuery = query;
    this.isSearchingVehicle = true;
    this.focus.search = true;
    this.httpService.searchMotorVehicle(query, this.vehicle.registrationStateCode || this.defaultRegStateCode).then(
      (result: any) => {
        if (!result) {
          return;
        }
        if(result.Source!=""){
         this.source= result?.Source
        }
        const { Vehicles, SearchType, Source } = result;

        if ((searchBy === 'VIN' || SearchType === 'VIN') && Vehicles.length !== 1) {
          const { year = '', make = '', model = '' } = this.vehicle;
          let searchTerm = year;
          searchTerm += searchTerm ? ` ${make}` : make;
          searchTerm += searchTerm ? ` ${model}` : model;
          if (searchBy !== 'fromSearchInput') {
            this.onSearchVehicle(searchTerm);
            return;
          }
        }

        if (this.dataService.isGainSightPXEnabled) {
          if(Vehicles?.length){
          const eventName = 'Vehicle Search';
          const payload = Vehicles.length
            ? {
              source: Source,
            }
            : {};
          this.helperService.postGainsightPXEvent(eventName, payload);
          }
        }

        if (this.isCarfaxEnabled) {
          this.vehicleSuggestions = [{ isHeader: true }];
        } else {
          this.vehicleSuggestions = [];
        }

        this.vehicleSuggestions = [...this.vehicleSuggestions, ...result.Vehicles.map((vehicle: any) => this.helperService.setVehicleMotorSearchResults(vehicle, this.vehicleQuery))];

        this.searchType = result.SearchType;
        this.isSearchingVehicle = false;
      },
      (err) => {
        this.isSearchingVehicle = false;
        this.helperService.showToaster('error', err);
      },
    );
  }

  onVehicleSelect(vehicle: any) {
    const data: any = this.helperService.setVehicleConnectedMotorData(vehicle, this.searchType, this.vehicleQuery);
    data.registrationState = this.vehicle.registrationState;
    data.registrationStateCode = this.vehicle.registrationStateCode;
    data.customerId = this.customerId;
    data.customerName = this.customer.fullName;

    if (data.vin) {
      data.VIN = data.vin;
    }
    if (data?.driveType?.name) {
      data.driveType = data.driveType.name;
    }
    if (data?.transmission?.value) {
      data.transmission = data.transmission.value;
    }
    delete data.connectedVia;

    this.httpService.updateMotorConnection(this.vehicle._id, data).then(
      (vehicle) => {
        // const companyData= this.helperService.getCompany()
        if ((vehicle.apiResponse != null && !vehicle?.apiResponse?.BaseVehicleID) || (vehicle?.isMotorConnected && vehicle.apiResponse === null)){
          this.helperService.motorEventGenerator(vehicle, 'notFound', 'Motor: Vehicle Not Found');
        } else {
          if ( vehicle?.apiResponse?.BaseVehicleID) {
            this.helperService.motorEventGenerator(vehicle, 'found', 'Vehicle Found - Motor');
            if (vehicle._id) {
              this.httpService.getVehicleFluidSpecifications(vehicle._id).then((data: any) => {
                if (!data.fliudSpecs || !data.fliudSpecs.length) {
                  this.helperService.motorEventGenerator(vehicle, 'notFound', 'Motor: Engine Specifications not Found');
                }
              });
            }
          }
        }
        if (!this.vehicle.isMotorConnected && vehicle.isMotorConnected) {
        //   const eventName = 'Vehicle Found - Motor'
        //   const date=new Date()
        //   // const source = this.source.toLowerCase() === 'motor 5.0' ? 
        //   // 'Motor Primary' : this.source.toLowerCase() === 'motor 4.5' ? 
        //   // 'Motor Secondary' : 'Motor Primary & Secondary';
        //   const payload={
        //     // source,
        //     tenantName:companyData.companyName,
        //     date: this.dateService.formatDate(date, datetimeFormat.mmmyyyy),
        //     time: this.dateService.getTime(date),
        //   }
      

        
          // this.helperService.postGainsightPXEvent(eventName, payload);
          this.helperService.showToaster('success', 'Vehicle was successfully linked');
        } else if (vehicle.isCarfaxConnected && !vehicle.isMotorConnected) {
          this.helperService.showToaster('error', 'Vehicle could not be connected to MOTOR. Please try searching for vehicle using another method (e.g. YMM)');
        } else {
          this.helperService.showToaster('success', `Vehicle was successfully ${vehicle.isMotorConnected ? 'updated' : 'disconnected'}`);
        }

        this.apiResponse = vehicle.apiResponse;
        this.vehicle.apiResponse = vehicle.apiResponse;
        this.vehicle.connectedVia = vehicle.connectedVia;
        this.vehicle.isCarfaxConnected = vehicle.isCarfaxConnected;
        this.vehicle.isMotorAndCarfaxSynced = vehicle.isMotorAndCarfaxSynced;
        this.vehicle.isMotorConnected = vehicle.isMotorConnected;
        this.isSearchFieldVisible = false;
        this.vehicleSuggestions = [];
        this.setMotorLinkTooltip();
        delete data.VIN;
        this.vehicle = {
          ...this.vehicle,
          ...data,
        };
        this.vehicle.year = Number(this.vehicle.year);
        this.vehicleUpdate.emit(this.vehicle);
        this.disabled = this.helperService.setVehicleDisabledFields(vehicle.isMotorConnected, vehicle.isCarfaxConnected, vehicle.connectedVia);

        if (this.highLightedVehicleId) {
          if (this.vehicle.transmission && this.vehicle.transmission.value) {
            this.vehicle.transmission = this.vehicle.transmission.value;
          } else {
            this.vehicle.transmission = null;
          }
          this.dataService.sendData(
            this.dataService.typeSidebar('close', null, null, {
              isSuccess: true,
              vehicle: {
                ...this.vehicle,
                isMotorConnected: !!this.apiResponse,
              },
              type: 'ro-vehicle',
            }),
          );
        }

        if (!vehicle.isMotorAndCarfaxSynced) {
          this.openChooseVehicleDialog();
        }
      },
      (err) => {
        if (this.isTransferVehicleEnabled) {
          this.errors.transferVehicleMotorError = 'Vehicle also exists under customer';
          // this.vehicle.isTransferButtonEnabled = true;
          this.currentCustomer = err.data.currentCustomer;
          if (err.data.customers) {
            err.data.customers.forEach((c) => {
              if (c.vehicles) {
                c.vehicles.map((v) => {
                  return (v.isChecked = false);
                });
              }
              this.customerList.push(c);
            });
            if (err.data.differentUser) {
              this.handleOpenTransferVehicleDialog();
            } else {
              if (this.customerList[this.customerList.length - 1].customerId === err.data.currentCustomer._id) {
                // this.vehicle.isTransferButtonEnabled = false;
                this.handleVehicleDuplication(err.data.customers[err.data.customers.length - 1].vehicles);
              }
            }
          }
        } else {
          this.helperService.showToaster('error', err);
        }
      },
    );
  }

  handleCloseVehicleSearch() {
    this.isSearchFieldVisible = false;
    this.vehicleQuery = '';
    this.vehicleSuggestions = [];
  }

  onColorUpdate({ name, color, _id }, type: string) {
    const tag = {
      _id,
      color: color,
      type,
      name: name.trim(),
    };

    this.httpService.updateTag(tag).then(
      (data) => {
        this.updateTags.emit(tag);
        for (let i = 0; i < this.vehicleColors.length; i++) {
          if (this.vehicleColors[i]._id === _id) {
            if (this.vehicle.color && this.vehicleColors[i].name === this.vehicle.color.name) {
              this.vehicle.color.name = name;
            }

            this.vehicleColors[i].name = name;
            break;
          }
        }

        for (let i = 0; i < this.vehicleColorsSuggestions.length; i++) {
          if (this.vehicleColorsSuggestions[i]._id === _id) {
            this.vehicleColorsSuggestions[i].name = name;
            break;
          }
        }
      },
      (err) => {
        this.helperService.showToaster('error', err);
      },
    );
  }

  onDriveTypeUpdate({ name, color, _id }, type: string) {
    const trimmedName = name.trim();

    // Case-insensitive duplicate check
    const duplicate = this.driverTypeSuggestions.some(
      (type) => type._id !== _id && type.name.toLowerCase() === trimmedName.toLowerCase()
    );

    if (duplicate) {
      this.helperService.showToaster('error', 'Drive type already exists.');
      return;
    }

    const tag = {
      _id,
      color: color,
      type,
      name: trimmedName,
    };

    this.httpService.updateTag(tag).then(
      (data) => {
        this.updateTags.emit(tag);

        for (let i = 0; i < this.driveTypes.length; i++) {
          if (this.driveTypes[i]._id === _id) {
            if (this.vehicle.driveType && this.driveTypes[i].name === this.vehicle.driveType.name) {
              this.vehicle.driveType.name = name;
            }

            this.driveTypes[i].name = name;
            break;
          }
        }

        for (let i = 0; i < this.driverTypeSuggestions.length; i++) {
          if (this.driverTypeSuggestions[i]._id === _id) {
            this.driverTypeSuggestions[i].name = name;
            break;
          }
        }
      },
      (err) => {
        this.helperService.showToaster('error', err);
      },
    );
  }

  onUpdateTags(data: any, type: string) {
    data.type = type;
    this.httpService.updateSupplier(data).then(
      (res) => {
        if (type === 'vehicle_color') {
          for (let i = 0; i < this.vehicleColors.length; i++) {
            if (this.vehicleColors[i]._id === data._id) {
              this.vehicleColors[i] = data;
            }
          }
        } else {
          for (let i = 0; i < this.driveTypes.length; i++) {
            if (this.driveTypes[i]._id === data._id) {
              this.driveTypes[i] = data;
            }
          }
        }
      },
      (err) => {
        this.helperService.showToaster('error', err);
      },
    );
  }

  showVehicleHistory() {
    if (!this.vehicle.licensePlateNo && !this.vehicle.vin) {
      return;
    }

    this.dialogService.open(CarfaxVehicleHistoryComponent, {
      styleClass: 'add-dialog carfax-history-dialog',
      showHeader: false,
      data: {
        vehicleId: this.vehicle._id,
      },
    });
  }

  openChooseVehicleDialog(isConfirmMode: boolean = false) {
    const ref = this.dialogService.open(UnsyncVehicleDialogComponent, {
      styleClass: `add-dialog ${isConfirmMode ? '' : 'carfax-history-dialog'}`,
      showHeader: false,
      data: {
        isConfirmMode,
        vehicleId: this.vehicle._id,
      },
    });

    const onClose = ref.onClose.subscribe(({ isSuccess, data }) => {
      if (isSuccess) {
        this.vehicle.year = data.year;
        this.vehicle.make = data.make;
        this.vehicle.model = data.model;
        this.vehicle.engine = data.engine;
        this.vehicle.name = data.name;
        this.vehicle.connectedVia = '';

        if (data.licensePlateNo) {
          this.vehicle.connectedVia = 'license';
          this.vehicle.licensePlateNo = data.licensePlateNo.toUpperCase();
        }

        if (data.VIN) {
          if (!data.connectedVia) {
            this.vehicle.connectedVia = 'vin';
          }

          this.vehicle.vin = data.VIN;
        }

        if (data.apiResponse && data.apiResponse.BaseVehicleID) {
          this.apiResponse = data.apiResponse;
          this.setMotorLinkTooltip();
        }
        this.vehicle.isCarfaxConnected = data.isCarfaxConnected;
        this.vehicle.isMotorConnected = data.isMotorConnected;
        this.vehicle.isMotorAndCarfaxSynced = true;
        this.updateVehicleConnectedStatus.emit();
        this.vehicleUpdate.emit(this.vehicle);
      } else {
        this.updateVehicleConnectedStatus.emit();
        this.vehicleUpdate.emit(this.vehicle);
      }

      // this.dataService.sendData(this.dataService.typeSidebar('close', null, null));
      onClose.unsubscribe();
    });
  }

  connectToCarfax() {
    if (this.isCarfaxConnecting) {
      return;
    }

    if (!this.vehicle.licensePlateNo && !this.vehicle.vin) {
      this.helperService.showToaster('error', 'Please save License plate or VIN to connect to Carfax');
      return;
    }

    this.isCarfaxConnecting = true;
    this.httpService
      .searchInVehicleCarfax({
        license: this.vehicle.licensePlateNo,
        vin: this.vehicle.vin,
        stateCode: this.vehicle.registrationStateCode,
      })
      .then(
        (res: any) => {
          this.isCarfaxConnecting = false;

          if (res && res.length) {
            this.onVehicleSelect(res[0]);
          } else {
            this.helperService.showToaster('error', 'Carfax cannot identify this License plate / VIN');
          }
        },
        (err) => {
          this.isCarfaxConnecting = false;
          this.helperService.showToaster('error', err);
        },
      );
  }

  checkVehicleNameUniqueness = debounce(() => {
    if (!this.vehicle.vehicleName || !this.customerId) {
      return;
    }

    if (this.helperService.trimString(this.vehicle.vehicleName) === this.helperService.trimString(this.vehicle.name)) {
      this.errors.vehicleName = '';
      this.isVehicleNameUnique = true;
      return;
    }
    this.isSavingVehicle = true;
    this.httpService.isVehicleNameUnique({ customerId: this.customerId, vehicleName: this.vehicle.vehicleName, vehicleId: this.vehicle._id }).then(
      ({ isUnique }) => {
        this.isSavingVehicle = false;
        this.isVehicleNameUnique = isUnique;
        this.errors.vehicleName = '';

        if (!this.isVehicleNameUnique) {
          this.errors.vehicleName = `This vehicle name exists for this customer`;
        }
      },
      (err) => {
        this.isSavingVehicle = false;
        this.helperService.showToaster('error', err);
      },
    );
  }, 400);

  showMileageHistory() {
    let history = ``;

    if (this.vehicleOdmHistory && this.vehicleOdmHistory.length > 0) {
      this.vehicleOdmHistory.forEach(({ readingDate, createdBy, reading, mileageMeasuringUnit, estimate }) => {
        /** @todo need to add a handle the 0 condition when flow will updated */
        if (Number(reading) >= 0) {
          history += `
            <div class="tooltip-2">
              <div class="tooltip-secondary-row seondary-row-padding font-12 font-gray-35 d-flex vehicle-tooltip-wrapper">
                <div class="tech-service font-800 font-gray-35 d-flex">
                  <i class="fal fa-clock align-self-start pt-1"></i>
                  <span class="tech-service-title">
                   ${this.dateService.formatDate(readingDate, datetimeFormat.mmmdyyhhmmaa)}
                  </span>
                </div>

                <div class="vehicle-miles font-12 font-gray-45 d-flex">
                      <i class="fal fa-tachometer-fast align-self-start"></i>

                      <span class="tech-service-title">
                        ${reading || 0} ${mileageMeasuringUnit === 'mi' ? 'miles' : 'km'}
                      </span>
                    </div>
                    <div class="vehicle-driver font-12 font-gray-45 d-flex">
                      <i class="fal fa-user-hard-hat align-self-start"></i>

                      <span class="tech-service-title">
                        ${createdBy && createdBy.userName ? createdBy.userName : ''}
                      </span>
                    </div>
                    <div class="vehicle-ro-number font-12 font-gray-45 d-flex">
                      <i class="fal fa-file-alt align-self-start"></i>

                      <span class="tech-service-title ${estimate?.isDeleted && 'font-red'}">
                        ${estimate?.estimateId ? (estimate?.isDeleted ? 'RO Deleted' : `RO# ${estimate.code}`) : ''}
                      </span>
                    </div>
              </div>
            </div>`;
        }
      });

      return `
        <div class="tooltip-seondary">
          <div class="tooltip-secondary-row font-14 font-bold font-secondary-800 divider-bottom">
            <i class="fal fa-car-mechanic"></i>${this.vehicle.name}
          </div>
          ${history}
        </div>`;
    }

    return '';
  }

  // Vehicle history
  vehicleHistory(vehicleId: string) {
    this.dialogService.open(AddVehicleHistoryComponent, {
      styleClass: 'add-dialog modal-stretched',
      showHeader: false,
      data: {
        vehicleId,
      },
    });
  }

  openAddTireStorageModal() {
    if (this.isTireStorageEnabled) {
      this.addTireStorageModal.emit(null);
    }
  }

  mergeVehicleModal() {
    const ref = this.dialogService.open(MergeVehicleDialogComponent, {
      width: '700px',
      styleClass: 'add-dialog',
      showHeader: false,
      data: {
        customerId: this.customerId,
        primaryVehicle: this.vehicle,
        vehicleList: this.vehicleList,
        isVehicleSidepanel: true,
      },
    });
  }

  handleTransferVehicle() {
    this.onSubmit(true);
  }

  handleOpenTransferVehicleDialog() {
    const ref = this.dialogService.open(TransferVehicleDialogComponent, {
      width: '740px',
      styleClass: 'add-dialog transfer-vehicle-dialog',
      showHeader: false,
      data: {
        customerList: this.customerList,
        customerId: this.customerId,
        vehicleName: this.vehicle.title,
        currentCustomer: this.currentCustomer,
        isShow: false,
        isMFConnected: this.vehicle?.isMFConnected,
      },
    });

    const onClose = ref.onClose.subscribe((data) => {
      if (data.type === 'close') {
        onClose.unsubscribe();
      } else if (data.type === 'updateVehicle') {
        const vehicle = data.selectedVehicle;
        this.updateVehicleSidebar(vehicle);
      }
    });
  }

  updateVehicleSidebar(data) {
    if (data) {
      // this.customer.fullName = data.customerName;
      this.vehicle = {
        ODM: data.ODM,
        VIN: data.VIN,
        apiResponse: data.apiResponse,
        color: { name: data.color || '' },
        connectedVia: data.connectedVia,
        _id: data.customerId,
        driveType: { name: data.driveType || '' },
        engine: data.engine,
        isActive: data.isActive,
        isCarfaxConnected: data.isCarfaxConnected,
        isMotorAndCarfaxSynced: data.isMotorAndCarfaxSynced,
        isMotorConnected: data.isMotorConnected,
        licensePlateNo: data.licensePlateNo || '',
        make: data.make,
        model: data.model,
        name: data.name,
        notes: data.notes || '',
        odmHistory: data.odmHistory || [],
        registrationState: data.registrationState || '',
        registrationStateCode: data.registrationStateCode || '',
        tags: data.tags || [],
        vehicleCheck: data.vehicleCheck,
        vehicleName: data.vehicleName,
        vin: data.VIN,
        year: data.year,
        vehicleId: data._id,
        title: data.vehicleName,
        vehicle: data.vehicleName,
        fullName: data.customerName,
        type: 'vehicle-add',
      };

      if (data.transmission) {
        this.vehicle.transmission = { label: data.transmission === 'automatic' ? 'Automatic' : 'Manual', value: data.transmission || '' };
      }

      if (data.ODM && data.ODM.length) {
        // let { reading, mileageMeasuringUnit } = data.ODM.pop();
        let { reading, mileageMeasuringUnit } = data.ODM[data.ODM.length - 1];

        this.vehicle.mileage = `${reading || ''}`;

        if (reading) {
          if (!mileageMeasuringUnit) {
            mileageMeasuringUnit = this.defaultMileageUnit;
          }

          this.vehicle.mileageMeasuringUnit = find(mileageUnits, {
            value: mileageMeasuringUnit,
          });
        }
      }

      this.errors.vin = '';
      this.errors.licensePlateNo = '';
    }
    this.type = data.type;
    this.isDuplicateVehicle = true;
    this.errors.vin = '';
    this.errors.licensePlateNo = '';

    this.openVehicleInSidePanel(this.vehicle);
  }

  openVehicleInSidePanel = (vehicelData) => {
    this.dataService.sendData(this.dataService.typeSidebar('vehicle', vehicelData._id, vehicelData.fullName, vehicelData));
  };

  handleVehicleDuplication(vehicleData) {
    const ref = this.dialogService.open(ConfirmDismissDialogComponent, {
      width: '30%',
      styleClass: 'small-heading-dialog',
      showHeader: false,
      data: {
        styleClassHeading: 'font-14',
        title: `Vehicle duplication`,
        message: `This vehicle cannot be created as a new vehicle because it already exists under this customer's name. However, you can proceed by updating the existing information for this vehicle`,
        button: {
          success: { title: 'Change & update', styleClass: 'btn-danger' },
          cancel: { title: 'Go back' },
        },
        headerIcon: 'fas fa-exclamation font-icon-red font-white',
      },
    });

    const onClose = ref.onClose.subscribe((close: any) => {
      if (close.isSuccess) {
        const data = { selectedVehicle: vehicleData[0] };
        const vehicle = data.selectedVehicle;
        this.updateVehicleSidebar(vehicle);
      }
      onClose.unsubscribe();
    });
  }

  isValidTransferActive = () => this.vehicle.isTransferActive && this.isTransferVehicleEnabled;

  isVehicleInActive = () => {
    if (this.isTransferVehicleEnabled) {
      return this.vehicle.isActive;
    } else {
      return true;
    }
  };

  copyVin(val) {
    this.clipboard.copy(val);
    this.helperService.showToaster('success', 'VIN Number copied');
    val.stopPropagation();
  }

  onSearchClear(event?: any) {
    this.isClearIconVisible = false;
  }

  customerSearch(query: string) {
    // this.isLoading = true;
  }

  getSelectedDriver(){
    if (this.vehicle?.driver?.driverId) {
      this.vehicle.driver = find(this.drivers, {
        _id: this.vehicle.driver.driverId,
      });
    }
  }

}
